import getProductToken from './getProductToken';

const getProductURL = (locale: string, ean: string, slug: string, params?: string): string => {
  const token = getProductToken(slug, ean);

  return `/${locale}/products/${token}/${params || ''}`;
};

export default getProductURL;
